import { IconButton, Stack } from '@mui/material';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import ActivityContainer from 'components/Common/ActivityContainerTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, store } from 'redux/store';
import { fetchAccountActivity } from 'redux/slices/dashboard/accountActivitySlice';
import { getAccountActivityTrxDetail, dateFormat, formatAmount, getTodayFilter, timeFormat, format } from 'utils/helpers';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
const AccountActivity = () => {
    const columns = [
        { id: 'transactionDate', label: 'Date', render: ({ data }: any) => dateFormat(data?.transactionDateTime) },
        { id: 'transactionTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.transactionDateTime, 'hh:mm A') },
        {
            id: 'username',
            label: 'From',
            render: ({ data }: any) => data?.filteredData?.fromUsername,
        },
        {
            id: 'companyName',
            label: 'To',
            render: ({ data }: any) => data?.filteredData?.toUsername,
        },
        { id: 'transactionType', label: 'Type', render: ({ data }: any) => data?.filteredData?.transactionType },
        {
            id: 'transaction',
            label: 'Payment',
            render: ({ data }: any) => formatAmount(data?.amount, 'dollar', data?.type),
        },
        { id: 'totalfee', label: 'Fee', render: ({ data }: any) => formatAmount(data?.filteredData?.totalFee, 'dollar', 'TRANSFER') },
        { id: 'amount', label: 'Total', render: ({ data }: any) => data?.filteredData?.amount },
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch<typeof store.dispatch>();
    const defaultCompanyId = useSelector((state: RootState) => state?.user.defaultCompanyId);
    const tableState = useSelector((state: RootState) => state.app.table);
    const { pageNumber, ...rest } = tableState;
    const [filter, setFilter] = useState<any>({ ...getTodayFilter(), ...rest });
    const accountActivity = useSelector((state: RootState) => state?.accountActivity);
    const { dashboardRecords, loading } = accountActivity || {};

    useEffect(() => {
        if (defaultCompanyId) {
            dispatch(fetchAccountActivity({ filter, type: 'dashboard' }));
        }
    }, [filter, dispatch, defaultCompanyId]);

    const navigationHandler = (row: any) => {
        const filterTrxData = getAccountActivityTrxDetail(row);
        navigate(routes.transactions.transactionDetails.replace(':transactionId', row?.confirmationCode?.toString()), {
            state: { dashboardNavigate: true, filterTrxData, showFeeSection: true },
        });
    };

    return (
        <>
            <Stack width={'100%'} direction={{ xs: 'column', sm: 'row' }}>
                <Stack width={'100%'} sx={{ backgroundColor: 'white', p: 1, mx: 2 }}>
                    <IconButton
                        onClick={() => navigate(routes.export_CSV_file.exportCSV)}
                        sx={{ alignSelf: 'end', mt: 3, position: 'absolute' }}
                    >
                        <IosShareOutlinedIcon />
                    </IconButton>
                    <ActivityContainer
                        navigationHandler={navigationHandler}
                        records={dashboardRecords}
                        columns={columns}
                        setFilter={setFilter}
                        filter={filter}
                        loading={loading}
                        serverSidePagination
                        defaultPagination={false}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default AccountActivity;
